export enum TenderResponseCode {
  RESERVATION_ACCEPTED = 'RESERVATION_ACCEPTED',
  RESERVATION_DECLINED = 'RESERVATION_DECLINED',
  RESERVATION_PENDING = 'RESERVATION_PENDING',
}
